import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { CancelToken } from 'axios';
import { Candidate } from '../candidate.interface';
export class ResumeService {
   async parseResume(cancelToken?: CancelToken, resume?: File, resume_url?: string) {
      const formData = new FormData();
      if (resume_url) {
         formData.append('resume_url', resume_url);
      }
      if (resume) {
         formData.append('resume', resume);
      }

      const response = await http.post<ApiResource<Candidate>>(`/candidates/resume/parse`, formData, {
         data: formData,
         cancelToken,
         headers: {
            'Content-Type': 'multipart/form-data',
         },
      });
      return response.data;
   }

   async processResumes(cancelToken: CancelToken, files: Array<File>) {
      const formData = new FormData();
      files.forEach((file) => {
         formData.append('resumes[]', file);
      });

      const response = await http.post<ApiResource<Candidate>>(`/candidates/resume/process`, formData, {
         data: formData,
         cancelToken,
         headers: {
            'Content-Type': 'multipart/form-data',
         },
      });
      return response.data;
   }
}
